export default __webpack_public_path__ + "static/Plots0096-9deabd842723452830df27726e7ee413.jpg";